
import React from 'react';
import ReactHlsPlayer from 'react-hls-player';
function Gif({release}){
    return <ReactHlsPlayer id={release.slug+"-gif"} src={release.additionalData.gif} autoPlay={true} loop muted playsInline className="release-gif" />
}
export default Gif;